import { render, staticRenderFns } from "./GameCatModal.vue?vue&type=template&id=4155bcb6&"
import script from "./GameCatModal.vue?vue&type=script&lang=js&"
export * from "./GameCatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports